import { COMING_SOON_FEATURES } from '../config/watermark';

/* The one check behind COMING_SOON_FEATURES (src/config/watermark.js).
   Routes, the sidebar, the topbar search and a feature's other entry
   points all ask here, so a url is hidden everywhere by listing it once. */

const normalize = (url) =>
  String(url || '')
    .split(/[?#]/)[0]
    .replace(/^\/+|\/+$/g, '')
    .toLowerCase();

const HIDDEN = (Array.isArray(COMING_SOON_FEATURES) ? COMING_SOON_FEATURES : [])
  .map(normalize)
  .filter(Boolean);

/** True when `url` is a listed feature or sits under one. */
export const isComingSoon = (url) => {
  const path = normalize(url);
  if (!path) return false;
  return HIDDEN.some((hidden) => path === hidden || path.startsWith(`${hidden}/`));
};

/**
 * A menu tree with every coming-soon item removed. A group whose every
 * child was removed goes too, rather than staying as an empty heading.
 */
export const withoutComingSoon = (items) =>
  (items || []).reduce((kept, item) => {
    if (item?.to && isComingSoon(item.to)) return kept;
    if (Array.isArray(item?.content) && item.content.length) {
      const content = withoutComingSoon(item.content);
      if (!content.length) return kept;
      kept.push({ ...item, content });
      return kept;
    }
    kept.push(item);
    return kept;
  }, []);
